<app-modal
  [isVisible]="isVisible()"
  [config]="modalConfig()"
  [primaryButtonDisabled]="primaryButtonDisabled()"
  [primaryButtonLoading]="isRequesting()"
  (confirmed)="onModalConfirmed()"
  (cancelled)="onModalCancelled()"
  (secondary)="onModalCancelled()"
  (closed)="onModalClosed()"
>
  @if (isRequesting()) {
    <app-modal-status
      variant="loading"
      [title]="'modals.request_review.loader_title' | transloco"
      [description]="'modals.request_review.loader_description' | transloco"
    >
      <app-huxley [state]="'thinking'" [size]="72" />
    </app-modal-status>
  } @else if (successMessage(); as msg) {
    <app-modal-status variant="success" [title]="msg">
      <app-huxley [state]="'success'" [size]="72" />
    </app-modal-status>
  } @else {
    <div class="modal-content">
      <!-- Branding -->
      <div class="header-logo">
        <img
          [ngSrc]="logoUrl()"
          [alt]="'modals.request_review.logo_alt' | transloco"
          width="1024"
          height="1024"
        />
        <span class="logo-text">{{ 'modals.request_review.header_title' | transloco }}</span>
      </div>

      <p class="modal-description">
        {{ 'modals.request_review.description' | transloco }}
      </p>

      <!-- No Subscription Warning -->
      @if (!hasActiveSubscription()) {
        <div class="subscription-warning">
          <app-sidebar-plan-widget
            variant="inline"
            [message]="'modals.request_review.subscription_required' | transloco"
            [actionText]="'modals.request_review.view_plans' | transloco"
            (action)="navigateToPricing()"
          />
        </div>
      }

      <!-- Error Message -->
      @if (error(); as err) {
        <div
          role="alert"
          [class.denied-banner]="bannerIsDenial()"
          [class.modal-error]="!bannerIsDenial()"
        >
          <span>{{ err }}</span>
          <button
            type="button"
            (click)="clearError()"
            [attr.aria-label]="'modals.shared.clear_error_aria' | transloco"
          >
            ×
          </button>
        </div>
      }

      <!-- Assessment & Price Info -->
      <div class="details-grid">
        @if (assessmentName(); as name) {
          <div class="detail-row">
            <span class="detail-label">{{
              'modals.request_review.field_assessment' | transloco
            }}</span>
            <span class="detail-value">{{ name }}</span>
          </div>
        }
        <div class="detail-row">
          <span class="detail-label">{{ 'modals.request_review.field_price' | transloco }}</span>
          <span class="detail-value detail-value--price">{{ formattedPrice() }}</span>
        </div>
      </div>

      <!-- Optional Message Field -->
      <div class="field">
        <label for="review-message">{{ 'modals.request_review.message_label' | transloco }}</label>
        <textarea
          id="review-message"
          [value]="message()"
          (input)="onMessageInput($event)"
          [placeholder]="'modals.request_review.message_placeholder' | transloco"
          rows="3"
          [disabled]="isRequesting()"
        ></textarea>
        <small>{{ 'modals.request_review.message_helper' | transloco }}</small>
      </div>
    </div>
  }
</app-modal>
